export default __webpack_public_path__ + "static/media/close-icon-red.2b201572.svg";